import { render } from "./RegisterSuccessModal.vue?vue&type=template&id=6968893e&scoped=true"
import script from "./RegisterSuccessModal.vue?vue&type=script&lang=js"
export * from "./RegisterSuccessModal.vue?vue&type=script&lang=js"

import "./custom-confirm-email.scss?vue&type=style&index=0&id=6968893e&lang=scss&scoped=true"
import "./RegisterSuccessModal.vue?vue&type=style&index=1&id=6968893e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6968893e"]])

export default __exports__